import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Card, CardContent, Chip } from "@mui/material";

const MeetingRoomCard = () => {
  const roomIds = useSelector((state) => state?.schedule?.roomIds);

  const meetingSpaces = useSelector(
    (state) => state?.allmeetingspaces?.allmeetingspaces
  );

  const selectedRooms = meetingSpaces?.filter((room) =>
    roomIds?.includes(room.id)
  );

  return (
    <Card sx={{ minWidth: 250, padding: 2, borderRadius: "10px", mt: 1 }}>
      <CardContent>
        <Typography variant="body" fontWeight="bold" color="primary">
          Venue
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
          {selectedRooms?.length > 0 ? (
            selectedRooms.map((room) => (
              <Chip
                key={room.id}
                label={room.name}
                color="primary"
                variant="outlined"
              />
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No meeting rooms selected.
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default MeetingRoomCard;
